import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { animated, useSpring } from '@react-spring/web';
import { ReactNode, useEffect } from 'react';
import { usePrevious } from 'react-use';
import styled from 'styled-components';

import { IconButton } from 'atoms/buttons/IconButton';
import { Horizontal } from 'atoms/layout/flex';
import { Color } from 'style/types';
import { regularMaterial } from 'style/utils';

const Wrapper = styled(animated(Horizontal))`
  min-width: min(100%, 500px);
  padding: var(--intermediate-unit) var(--double-unit);
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);
  align-items: center;
  justify-content: space-between;
  ${regularMaterial}
`;

type Props = {
  nbCardsSelected: number;
  color: Color;
  onCancel: () => void;
  children: ReactNode;
  button: ReactNode;
};

export const SelectionSummary = ({
  nbCardsSelected,
  color,
  button,
  children,
  onCancel,
}: Props) => {
  const previousNbCardsSelected = usePrevious(nbCardsSelected);

  const [styles, api] = useSpring(() => ({
    from: {
      borderColor: 'var(--c-nd-150)',
    },
  }));

  useEffect(() => {
    if (previousNbCardsSelected !== nbCardsSelected) {
      if ((previousNbCardsSelected || 0) < nbCardsSelected) {
        api.start({
          to: [{ borderColor: color }, { borderColor: 'var(--c-nd-150)' }],
        });
      } else if ((previousNbCardsSelected || 0) > nbCardsSelected) {
        api.start({
          to: [
            { borderColor: 'var(--c-nd-400)' },
            { borderColor: 'var(--c-nd-150)' },
          ],
        });
      }
    }
  }, [api, color, nbCardsSelected, previousNbCardsSelected]);

  return (
    <Wrapper style={styles}>
      {children}
      <Horizontal>
        {button}
        <IconButton
          size="medium"
          onClick={onCancel}
          icon={faTimes}
          color="red"
        />
      </Horizontal>
    </Wrapper>
  );
};
